import { Column } from '@tanstack/react-table';
import { Button } from './ui/button';
import { ArrowUpDown } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

import { cn, ROIGuidance } from '..';

export function renderTableCell(
  children: string | React.ReactNode,
  className?: string,
) {
  return (
    <div
      className={cn('flex justify-start font-medium text-gray-600', className)}
    >
      {children}
    </div>
  );
}

export function renderHeaderCell(
  children: string | React.ReactNode,
  className?: string,
  tooltipText?: string,
) {
  const cellContent = (
    <div
      className={cn(
        'flex justify-start whitespace-nowrap font-medium text-primary-dark',
        className,
      )}
    >
      {children}
    </div>
  );

  if (tooltipText) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>{cellContent}</TooltipTrigger>
          <TooltipContent>
            <p>{tooltipText}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return cellContent;
}

export function SortHeader<TData>({
  column,
  children,
  variant = 'ghost',
  showRoiTooltip = false,
}: {
  column: Column<TData, any>;
  children: string | React.ReactNode;
  variant?: 'link' | 'ghost';
  showRoiTooltip?: boolean;
}) {
  const isSorted = column.getIsSorted();
  const rotation = isSorted === 'desc' ? 'rotate-180' : '';
  return (
    <div className="flex items-center gap-0">
      <span className="whitespace-nowrap">{children}</span>
      {showRoiTooltip && <ROIGuidance className="ml-1 w-max p-0.5 [&_svg]:!size-3 [&_svg]:p-0" />}
      <Button
        variant={variant}
        size="sm"
        onClick={() => column.toggleSorting(column.getIsSorted() === 'asc')}
        className={`text-primary-dark ml-0.5 p-2 font-medium ${variant === 'link' ? 'hover:text-primary-hover p-1.5' : 'hover:bg-primary-100'}`}
      >
        <ArrowUpDown
          strokeWidth={1.5}
          size={12}
          className={`${rotation} text-primary-dark transition-transform`}
        />
      </Button>
    </div>
  );
}
